import Modal from '../_dashboard/blog/ProjectModel'
import * as Yup from 'yup'
import { useFormik, Form, FormikProvider } from 'formik'
import { Edit, PhotoCamera, Close } from '@material-ui/icons'
import {
  UploadAvatar,
  UploadMultiFile,
  UploadSingleFile,
} from 'src/components/upload'
import { fData } from 'src/utils/formatNumber'
import { storage } from 'src/firebase/firebase'
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage'
import axios from 'axios'
import {
  alpha,
  useTheme,
  experimentalStyled as styled,
} from '@material-ui/core/styles'
import moment from 'moment'
import { REST_API_END_POINT } from 'src/constants/Defaultvalues'
import SendDesignsEmailModal from 'src/components/_dashboard/official-request/SendDesignsEmailModal'
import { useSnackbar } from 'notistack'
import {
  Box,
  Card,
  Grid,
  Stack,
  Typography,
  Button,
  TextField,
  FormControl,
  FormLabel,
  Select,
  MenuItem,
  Autocomplete,
  RadioGroup,
  FormControlLabel,
  Radio,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
} from '@material-ui/core'
import { LoadingButton, MobileDatePicker } from '@material-ui/lab'
import { useCallback, useEffect, useRef, useState } from 'react'
import { sentenceCase } from 'change-case'
import arrowLeftOutlined from '@iconify/icons-ant-design/arrow-left-outlined'
import arrowRightOutlined from '@iconify/icons-ant-design/arrow-right-outlined'
import { Icon } from '@iconify/react'
import { supabase } from '../../supabase/supabaseClient'
import AttachmentDownloadIconButton from 'src/components/_dashboard/official-request/AttachmentDownloadIconButton'
import AttachmentDownloadAllButton from 'src/components/_dashboard/official-request/AttachmentDownloadAllButton'

const LabelStyle = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtitle2,
  color: theme.palette.text.secondary,
  //   marginBottom: theme.spacing(1)
}))
const LabelStyleHead = styled(Typography)(({ theme }) => ({
  ...theme.typography.h5,
  color: theme.palette.text.secondary,
}))

const getInstallPhotoSelectKey = (file, index = 0) => {
  if (!file) return `idx:${index}`
  const url = file.value || file.url || file.preview || ''
  if (url) return String(url)
  if (file.id != null) return `id:${file.id}`
  return `idx:${index}`
}

const getUrlExtension = (url = '') => {
  try {
    const parsedUrl = new URL(url, window.location.origin)

    // Secure attachment URLs store the real file path in ?path=
    const actualPath = parsedUrl.searchParams.get('path') || parsedUrl.pathname

    const decodedPath = decodeURIComponent(actualPath)
    const fileName = decodedPath.split('/').pop() || ''
    const match = fileName.match(/\.([a-z0-9]{2,5})$/i)

    if (match) {
      return match[1].toLowerCase()
    }
  } catch (error) {
    // fall through
  }

  return 'jpg'
}

const buildInstallPhotoDisplayName = (installationName, index, url) => {
  const base = String(installationName || 'Installation')
    .trim()
    .replace(/[<>:"/\\|?*]/g, '_')
  const ext = getUrlExtension(url)
  return `${base} - Photo ${index + 1}.${ext}`
}

const toInstallPhotoEmailReport = (file, index = 0, installationName = '') => {
  const url = file?.value || file?.url || file?.preview || ''
  if (!url) return null
  const displayName = buildInstallPhotoDisplayName(installationName, index, url)
  return {
    id: file.id || file.field_id || index,
    report_name: displayName,
    file_name: displayName,
    displayName,
    report_pdf_url: url,
    url,
    preview: url,
    name: displayName,
  }
}

/** Map install-report photo fields (URL in `value`) to attachment download shape. */
const toInstallPhotoDownloadFile = (file, index = 0) => {
  if (!file) return null
  const url =
    typeof file === 'string'
      ? file
      : file.value || file.url || file.preview || ''
  if (!url) return null
  const rawName =
    typeof file === 'object'
      ? file.displayName ||
        (file.name &&
        file.name !== 'file' &&
        !String(file.name).includes('://')
          ? file.name
          : null)
      : null
  return {
    url,
    preview: url,
    name: rawName || `install-photo-${index + 1}`,
    file_type: 'image/',
  }
}

const isInstallPhotoDownloadRestricted = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    const userType = user?.isClient ? 3 : user?.user_type
    return Boolean(user?.isClient || userType === 3)
  } catch {
    return false
  }
}

export default function EditViewTemplate({
  openEdit,
  setOpenEdit,
  templateData,
  label,
  fetchTemplateData,
  instId,
  templateId,
  installationName,
  installationJobName,
  orderNumber,
  projectName,
  clientName,
  installNote,
  teamNames,
  published
}) {
  const user = localStorage.getItem('user')
  const userData = JSON.parse(user)
  const theme = useTheme()
  const { enqueueSnackbar } = useSnackbar()
  const [openImageModal, setOpenImageModal] = useState(false)
  const [currentImageIndex, setCurrentImageIndex] = useState(0)
  const [imageList, setImageList] = useState([])
  const imageFilesRef = useRef([])
  const NewUserSchema = Yup.object().shape({})
  const [imageFiles, setImageFiles] = useState([])
  const [selectedPhotoKeys, setSelectedPhotoKeys] = useState([])
  const [openInstallEmailModal, setOpenInstallEmailModal] = useState(false)
  const [emailModalReports, setEmailModalReports] = useState([])
  const [pendingPhotos, setPendingPhotos] = useState([])
  const [savingPhotos, setSavingPhotos] = useState(false)
  const [fileFieldMeta, setFileFieldMeta] = useState(null)
  const [galleryRefreshKey, setGalleryRefreshKey] = useState(0)
  const [openAddPhotosModal, setOpenAddPhotosModal] = useState(false)
  const userType = userData?.isClient ? 3 : userData?.user_type
  const canEmailPhotos =
    label === 'view_template' && !userData?.isClient && userType !== 3 && published ===1
  const canUploadPhotos = !userData?.isClient && userType !== 3
  const resolvedTemplateId = templateId || templateData?.[0]?.template_id
  const [cameraOpen, setCameraOpen] = useState(false)
  const [cameraTarget, setCameraTarget] = useState(null)
  const [isCapturingPhoto, setIsCapturingPhoto] = useState(false)
  const videoRef = useRef(null)
  const canvasRef = useRef(null)
  const streamRef = useRef(null)
  const canExportPhotos = !isInstallPhotoDownloadRestricted()
  const installPhotoDownloadFiles = imageFiles
    .map((file, index) => toInstallPhotoDownloadFile(file, index))
    .filter(Boolean)
  const selectedPhotoDownloadFiles = imageFiles
    .map((file, index) => {
      const key = getInstallPhotoSelectKey(file, index)
      if (!selectedPhotoKeys.includes(key)) return null
      return toInstallPhotoDownloadFile(file, index)
    })
    .filter(Boolean)

  useEffect(() => {
    const validKeys = new Set(
      imageFiles.map((file, index) => getInstallPhotoSelectKey(file, index)),
    )
    setSelectedPhotoKeys((prev) => prev.filter((key) => validKeys.has(key)))
  }, [imageFiles])


  const handleToggleSelectAllPhotos = (checked) => {
    if (checked) {
      setSelectedPhotoKeys(
        imageFiles.map((file, index) => getInstallPhotoSelectKey(file, index)),
      )
      return
    }
    setSelectedPhotoKeys([])
  }
  console.log('templateData----', templateData)
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: templateData?.reduce((acc, curr) => {
      acc[curr.content] = curr.value
      return acc
    }, {}),

    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        const formData = Object.keys(values).map((key) => {
          const fieldData = templateData.find((item) => item.content === key)
          return {
            ...fieldData,
            value: values[key],
          }
        })
        axios
          .post(`${REST_API_END_POINT}installation/update-inst-template`, {
            formData,
          })
          .then((res) => {
            if (res.data.status == 1) {
              enqueueSnackbar(res.data.message, { variant: 'success' })
              setOpenEdit(false)
              fetchTemplateData()
            } else {
              enqueueSnackbar(res.data.message, { variant: 'error' })
            }
          })
      } catch (error) {}
    },
  })
  const {
    errors,
    values,
    touched,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    getFieldProps,
  } = formik
  console.log('values----', values)
  // const handleDropFile = useCallback(
  //   async (acceptedFiles, field_id, content) => {
  //     try {
  //       if (acceptedFiles && acceptedFiles.length > 0) {
  //         const file = acceptedFiles[0]
  //         const filename = new Date().getTime() + file.name

  //         const storageRef = ref(storage, filename)
  //         const uploadTask = uploadBytesResumable(storageRef, file)

  //         uploadTask.on(
  //           'state_changed',
  //           (snapshot) => {
  //             const newProgress = Math.round(
  //               (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
  //             )
  //           },
  //           (error) => {
  //             console.error('Error during upload:', error)
  //           },
  //           async () => {
  //             const downloadURL = await getDownloadURL(uploadTask.snapshot.ref)

  //             setFieldValue(content,downloadURL)
  //           },
  //         )
  //       }
  //     } catch (error) {
  //       console.error('Unexpected error:', error)
  //     }
  //   },
  //   [setFieldValue],
  // )
  const parseContent = (htmlContent) => {
    const doc = new DOMParser().parseFromString(htmlContent, 'text/html')
    return doc.body.textContent || ''
  }
  // Prefer the report template "Install notes" field (shown in View Report).
  // Fall back to the job-level installNote prop (installations.install_notes) from ALL-1449.
  const templateInstallNote =
    templateData?.find((item) => {
      if (item?.value == null || !String(item.value).trim()) return false
      const label = parseContent(String(item.content || ''))
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase()
      return label === 'install notes' || label === 'install note'
    })?.value
  const resolvedInstallNote =
    (templateInstallNote != null && String(templateInstallNote).trim()) ||
    installNote ||
    ''
  const rightContentStyle = { color:theme.palette.mode === 'light' ? "#00a6e7" : "#1ccaff" }

  // const handleImageClick = (selectedImage, allImages) => {
  //   setImageList(allImages);  // Store all images in state
  //   setCurrentImageIndex(allImages.indexOf(selectedImage)); // Set index
  //   setOpenImageModal(true);
  // };
  const handleImageClick = (selectedImage, allImages) => {
    const imageUrls = allImages.map((img) => img.value) // Extract only URLs
    setImageList(imageUrls) // Store only image URLs in state
    setCurrentImageIndex(imageUrls.indexOf(selectedImage)) // Set index correctly
    setOpenImageModal(true)
  }

  const handlePrevious = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : imageList.length - 1,
    )
  }

  const handleNext = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex < imageList.length - 1 ? prevIndex + 1 : 0,
    )
  }

  // const handleDropFile = useCallback(
  //   async (acceptedFiles, field_id, content) => {
  //     try {
  //       if (acceptedFiles && acceptedFiles.length > 0) {
  //         let uploadedFiles = []

  //         for (const file of acceptedFiles) {
  //           const filename = new Date().getTime() + file.name
  //           const storageRef = ref(storage, filename)
  //           const uploadTask = uploadBytesResumable(storageRef, file)

  //           await new Promise((resolve, reject) => {
  //             uploadTask.on(
  //               'state_changed',
  //               null,
  //               (error) => {
  //                 console.error('Error during upload:', error)
  //                 reject(error)
  //               },
  //               async () => {
  //                 const downloadURL = await getDownloadURL(
  //                   uploadTask.snapshot.ref,
  //                 )
  //                 uploadedFiles.push({
  //                   field_id,
  //                   value: downloadURL,
  //                   content: 'file',
  //                   preview: downloadURL,
  //                   name: file.name,
  //                 })
  //                 resolve()
  //               },
  //             )
  //           })
  //         }
  //         setFieldValue((prevForm) => {
  //           let newForm = { ...prevForm };
  //           const existingKeys = Object.keys(newForm).filter((key) => key.startsWith(content));
  //           const lastIndex = existingKeys.length > 0 
  //             ? Math.max(...existingKeys.map(key => parseInt(key.split("_").pop(), 10) || 0))
  //             : 0;
  //           uploadedFiles.forEach((file, index) => {
  //             newForm[`${content}_${lastIndex + index + 1}`] = file;
  //           });
          
  //           return newForm;
  //         }); 

  //         // setFieldValue((prevForm) => {
  //         //   let newForm = { ...prevForm }

  //         //   uploadedFiles.forEach((file, index) => {
  //         //     newForm[`${content}_${Date.now()}_${index + 1}`] = file
  //         //   })

  //         //   return newForm
  //         // })
  //       }
  //     } catch (error) {
  //       console.error('Unexpected error:', error)
  //     }
  //   },
  //   [setFieldValue],
  // )

  const handleDropFile = useCallback(
    async (acceptedFiles, field_id, content) => {
      try {
        if (!acceptedFiles?.length) return;

        const uploadedFiles = [];

        for (const file of acceptedFiles) {
          /* ---------- build a unique storage path ---------- */
          const ts = Date.now();
          const cleanName = file.name.replace(/\s+/g, '_');
          const fileName = `${ts}_${cleanName}`;
          const filePath = `installations/installation-template/attachments/${fileName}`;

          /* ---------- upload ---------- */
          const { error: upErr } = await supabase
            .storage
            .from('signwise-attachments')        // bucket name
            .upload(filePath, file);

          if (upErr) {
            console.error('Upload error:', upErr.message);
            continue;                            // skip this file
          }

          /* ---------- public URL ---------- */
          const { data: urlData, error: urlErr } = supabase
            .storage
            .from('signwise-attachments')
            .getPublicUrl(filePath);

          if (urlErr || !urlData?.publicUrl) {
            console.error(urlErr?.message || 'URL generation failed');
            continue;
          }

          uploadedFiles.push({
            field_id,
            value: urlData.publicUrl,
            content: 'file',
            preview: urlData.publicUrl,
            name: file.name
          });
        }

        if (!uploadedFiles.length) return;

        /* ---------- merge into Formik state ---------- */
        setFieldValue(prev => {
          const newForm = { ...prev };
          const existingKeys = Object.keys(newForm).filter(k => k.startsWith(content));
          const lastIndex = existingKeys.length
            ? Math.max(...existingKeys.map(k => parseInt(k.split('_').pop() || '0', 10)))
            : 0;

          uploadedFiles.forEach((file, i) => {
            newForm[`${content}_${lastIndex + i + 1}`] = file;
          });

          return newForm;
        });

      } catch (err) {
        console.error('Unexpected error:', err);
      }
    },
    [setFieldValue]
  );

  const stopCameraStream = useCallback((stream) => {
    if (stream) {
      stream.getTracks().forEach((track) => track.stop())
    }
  }, [])

  const attachStreamToVideo = useCallback(() => {
    const video = videoRef.current
    const stream = streamRef.current
    if (!video || !stream) return

    video.setAttribute('playsinline', 'true')
    video.setAttribute('webkit-playsinline', 'true')
    video.muted = true
    video.playsInline = true
    video.autoplay = true

    if (video.srcObject !== stream) {
      video.srcObject = stream
    }

    const tryPlay = () => {
      const playPromise = video.play()
      if (playPromise?.catch) {
        playPromise.catch((err) => console.error('Video play error:', err))
      }
    }

    if (video.readyState >= 2) {
      tryPlay()
    } else {
      video.onloadedmetadata = () => {
        tryPlay()
      }
      setTimeout(tryPlay, 250)
    }
  }, [])

  const handleCloseCamera = useCallback(() => {
    if (videoRef.current) {
      videoRef.current.srcObject = null
      videoRef.current.onloadedmetadata = null
    }
    stopCameraStream(streamRef.current)
    streamRef.current = null
    setCameraOpen(false)
    setCameraTarget(null)
    setIsCapturingPhoto(false)
  }, [stopCameraStream])

  const handleOpenCamera = useCallback(async (field_id, content) => {
    if (!navigator.mediaDevices?.getUserMedia) {
      enqueueSnackbar('Camera is not supported in this browser.', { variant: 'error' })
      return
    }
    try {
      stopCameraStream(streamRef.current)
      streamRef.current = null

      let stream
      const attempts = [
        { video: { facingMode: 'environment' }, audio: false },
        { video: { facingMode: { ideal: 'environment' } }, audio: false },
        { video: { facingMode: 'user' }, audio: false },
        { video: true, audio: false },
      ]

      let lastError = null
      for (const constraints of attempts) {
        try {
          stream = await navigator.mediaDevices.getUserMedia(constraints)
          break
        } catch (err) {
          lastError = err
        }
      }

      if (!stream) {
        throw lastError || new Error('Camera unavailable')
      }

      streamRef.current = stream
      setCameraTarget({ field_id, content })
      setCameraOpen(true)
      requestAnimationFrame(() => {
        setTimeout(() => attachStreamToVideo(), 50)
      })
    } catch (error) {
      console.error('Camera access error:', error)
      enqueueSnackbar('Unable to access camera. Please allow camera permission.', {
        variant: 'error',
      })
    }
  }, [attachStreamToVideo, enqueueSnackbar, stopCameraStream])

  const handleCapturePhoto = useCallback(async () => {
    if (!videoRef.current || !cameraTarget) return
    try {
      setIsCapturingPhoto(true)
      const video = videoRef.current

      if (!video.videoWidth || !video.videoHeight) {
        enqueueSnackbar('Camera is still loading. Please wait a moment and try again.', {
          variant: 'warning',
        })
        setIsCapturingPhoto(false)
        attachStreamToVideo()
        return
      }

      const canvas = canvasRef.current || document.createElement('canvas')
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight
      const ctx = canvas.getContext('2d')
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height)

      const blob = await new Promise((resolve) =>
        canvas.toBlob(resolve, 'image/jpeg', 0.85)
      )
      if (!blob) {
        enqueueSnackbar('Failed to capture photo. Please try again.', { variant: 'error' })
        setIsCapturingPhoto(false)
        return
      }

      const file = new File([blob], `install_photo_${Date.now()}.jpg`, {
        type: 'image/jpeg',
      })
      const { field_id, content } = cameraTarget
      handleCloseCamera()
      await handleDropFile([file], field_id, content)
    } catch (error) {
      console.error('Capture photo error:', error)
      enqueueSnackbar('Failed to capture photo. Please try again.', { variant: 'error' })
      setIsCapturingPhoto(false)
    }
  }, [attachStreamToVideo, cameraTarget, enqueueSnackbar, handleCloseCamera, handleDropFile])

  useEffect(() => {
    if (!cameraOpen || !streamRef.current) return
    const timers = [
      setTimeout(() => attachStreamToVideo(), 100),
      setTimeout(() => attachStreamToVideo(), 400),
    ]
    return () => timers.forEach(clearTimeout)
  }, [cameraOpen, attachStreamToVideo])

  useEffect(() => {
    return () => {
      if (videoRef.current) {
        videoRef.current.srcObject = null
      }
      stopCameraStream(streamRef.current)
      streamRef.current = null
    }
  }, [stopCameraStream])

  useEffect(() => {
    // if (imageFiles.length === 0 && templateData?.length > 0) {
    //
    //   const uniqueFileData = Array.from(
    //     new Map(
    //       templateData
    //         .filter((item) => item.name === 'file' && item.value)
    //         .map((item) => [item.id, { ...item }]),
    //     ).values(),
    //   )
    //
    //   setImageFiles(uniqueFileData)
    //   console.log('Computed imageFiles:', uniqueFileData)
    // }
    if (templateData?.length > 0) {

      const uniqueFileData = Array.from(
        new Map(
          templateData
            .filter((item) => item.name === 'file' && item.value)
            .map((item) => [item.id, { ...item }]),
        ).values(),
      )

      setImageFiles(uniqueFileData)
      console.log('Computed imageFiles:', uniqueFileData)
    }
  }, [templateData])

  useEffect(() => {
    if (galleryRefreshKey === 0 || !templateData?.length) return

    const uniqueFileData = Array.from(
      new Map(
        templateData
          .filter((item) => item.name === 'file' && item.value)
          .map((item) => [item.id, { ...item }]),
      ).values(),
    )

    setImageFiles(uniqueFileData)
  }, [templateData, galleryRefreshKey])

  useEffect(() => {
    if (!openEdit) {
      setPendingPhotos([])
      setGalleryRefreshKey(0)
      return
    }

    const existingFileField = templateData?.find((item) => item.name === 'file')
    if (existingFileField) {
      setFileFieldMeta({
        field_id: existingFileField.field_id,
        content: existingFileField.content,
      })
      return
    }

    if (!resolvedTemplateId) return

    axios
      .post(`${REST_API_END_POINT}installation/template-view`, {
        id: resolvedTemplateId,
      })
      .then((res) => {
        const fields = res.data?.data?.[0]?.fields || {}
        const fileField = Object.values(fields).find((field) => field.tag === 'file')
        if (fileField) {
          setFileFieldMeta({
            field_id: fileField.field_id,
            content: fileField.content,
          })
        }
      })
      .catch((error) => {
        console.error('Failed to load template file field:', error)
      })
  }, [openEdit, templateData, resolvedTemplateId])

  useEffect(() => {
    const validKeys = new Set(
      imageFiles.map((file, index) => getInstallPhotoSelectKey(file, index)),
    )
    setSelectedPhotoKeys((prev) => prev.filter((key) => validKeys.has(key)))
  }, [imageFiles])

  const handleTogglePhotoSelect = (file, index, checked) => {
    const key = getInstallPhotoSelectKey(file, index)
    setSelectedPhotoKeys((prev) =>
      checked ? [...new Set([...prev, key])] : prev.filter((k) => k !== key),
    )
  }

  const handleSendInstallPhotos = () => {
    const selectedReports = imageFiles
      .map((file, index) => {
        const key = getInstallPhotoSelectKey(file, index)
        if (!selectedPhotoKeys.includes(key)) return null
        return toInstallPhotoEmailReport(file, index, installationName)
      })
      .filter(Boolean)

    if (!selectedReports.length) {
      enqueueSnackbar('Please select at least one photo', { variant: 'warning' })
      return
    }
    setEmailModalReports(selectedReports)
    setOpenInstallEmailModal(true)
  }

  const handleDropPendingPhotos = useCallback(async (acceptedFiles) => {
    try {
      if (!acceptedFiles?.length) return

      const uploadedFiles = []

      for (const file of acceptedFiles) {
        const ts = Date.now()
        const cleanName = file.name.replace(/\s+/g, '_')
        const fileName = `${ts}_${cleanName}`
        const filePath = `installations/installation-template/attachments/${fileName}`

        const { error: upErr } = await supabase.storage
          .from('signwise-attachments')
          .upload(filePath, file)

        if (upErr) {
          console.error('Upload error:', upErr.message)
          continue
        }

        const { data: urlData, error: urlErr } = supabase.storage
          .from('signwise-attachments')
          .getPublicUrl(filePath)

        if (urlErr || !urlData?.publicUrl) {
          console.error(urlErr?.message || 'URL generation failed')
          continue
        }

        uploadedFiles.push({
          value: urlData.publicUrl,
          preview: urlData.publicUrl,
          name: file.name,
        })
      }

      if (!uploadedFiles.length) {
        enqueueSnackbar('Failed to upload photos', { variant: 'error' })
        return
      }

      setPendingPhotos((prev) => [...prev, ...uploadedFiles])
    } catch (err) {
      console.error('Unexpected error:', err)
      enqueueSnackbar('Failed to upload photos', { variant: 'error' })
    }
  }, [enqueueSnackbar])

  const handleRemovePendingPhoto = (photoToRemove) => {
    setPendingPhotos((prev) =>
      prev.filter((photo) => photo.value !== photoToRemove.url),
    )
  }

  const handleSaveNewPhotos = async () => {
    if (!pendingPhotos.length) {
      enqueueSnackbar('Please upload at least one photo', { variant: 'warning' })
      return
    }

    if (!instId || !resolvedTemplateId) {
      enqueueSnackbar('Installation or template information is missing', {
        variant: 'error',
      })
      return
    }

    setSavingPhotos(true)
    try {
      const fieldStatus = templateData?.some((row) => Number(row.status) === 1)
        ? 1
        : 0

      const res = await axios.post(
        `${REST_API_END_POINT}installation/append-install-photos`,
        {
          installation_id: instId,
          template_id: resolvedTemplateId,
          field_id: fileFieldMeta?.field_id,
          photos: pendingPhotos.map((photo) => ({ value: photo.value })),
          field_status: fieldStatus,
        },
      )

      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message || 'Photos added successfully', {
          variant: 'success',
        })
        const appendedPhotos = pendingPhotos.map((photo, index) => ({
          id: `new-${Date.now()}-${index}`,
          name: 'file',
          content: fileFieldMeta?.content || 'Install photos',
          field_id: fileFieldMeta?.field_id,
          value: photo.value,
          template_id: resolvedTemplateId,
          installation_id: instId,
        }))
        setImageFiles((prev) => [...prev, ...appendedPhotos])
        setPendingPhotos([])
        if (fetchTemplateData) {
          fetchTemplateData()
        }
        setGalleryRefreshKey((prev) => prev + 1)
        setOpenAddPhotosModal(false)
      } else {
        enqueueSnackbar(res.data.message || 'Failed to add photos', {
          variant: 'error',
        })
      }
    } catch (error) {
      console.error('handleSaveNewPhotos error:', error)
      enqueueSnackbar('Failed to add photos', { variant: 'error' })
    } finally {
      setSavingPhotos(false)
    }
  }

  return (
    <Modal
      open={openEdit}
      handleClose={() => {
        setOpenEdit(false)
      }}
      modalTitle={label === 'edit_template' ? 'Edit Report' : 'View Report'}
    >
      <FormikProvider value={formik}>
        <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
          <Grid
            container
            spacing={3}
            alignItems={'center'}
            justifyContent={'center'}
          >
            <Grid item xs={12} md={8}>
              {/* <Card sx={{ p: 3 }}>  */}
              <Stack spacing={3}>
                {label !== 'view_template' &&
                  templateData?.map((data) => {
                    const { name, content, field_id, installation_id, value } =
                      data
                    switch (name) {
                      case 'textarea':
                        return (
                          <TextField
                            key={value.id}
                            label={
                              <div
                                style={{ whiteSpace: 'pre-wrap' }}
                                dangerouslySetInnerHTML={{ __html: content }}
                              />
                            }
                            fullWidth
                            id={'text'}
                            value={values[content]}
                            onChange={(event) =>
                              setFieldValue(content, event.target.value)
                            }
                            sx={{
                              width: '100%',
                              marginTop: '8px',
                              padding: '8px',
                            }}
                          />
                        )
                      case 'text':
                        return (
                          <TextField
                            key={value.id}
                            label={
                              <div
                                style={{ whiteSpace: 'pre-wrap' }}
                                dangerouslySetInnerHTML={{ __html: content }}
                              />
                            }
                            fullWidth
                            id={'text'}
                            value={values[content]}
                            onChange={(event) =>
                              setFieldValue(content, event.target.value)
                            }
                            sx={{
                              width: '100%',
                              marginTop: '8px',
                              padding: '8px',
                            }}
                          />
                        )
                      case 'date':
                        return (
                          <Box
                            key={content}
                            component={MobileDatePicker}
                            label={
                              <div
                                style={{ whiteSpace: 'pre-wrap' }}
                                dangerouslySetInnerHTML={{ __html: content }}
                              />
                            }
                            placeholder={
                              <div
                                style={{ whiteSpace: 'pre-wrap' }}
                                dangerouslySetInnerHTML={{ __html: content }}
                              />
                            }
                            value={values[content]}
                            onChange={(date) =>
                              setFieldValue(
                                content,
                                moment(date).format('YYYY-MM-DD'),
                              )
                            }
                            renderInput={(params) => (
                              <TextField size="small" {...params} fullWidth />
                            )}
                          />
                        )
                      case 'number':
                        return (
                          <TextField
                            key={value.id}
                            label={
                              <div
                                style={{ whiteSpace: 'pre-wrap' }}
                                dangerouslySetInnerHTML={{ __html: content }}
                              />
                            }
                            type="number"
                            fullWidth
                            value={values[content]}
                            onChange={(event) =>
                              setFieldValue(content, event.target.value)
                            }
                          />
                        )
                      case 'select':
                        return (
                          <FormControl>
                            <FormLabel id="demo-select-label">
                              {
                                <div
                                  style={{ whiteSpace: 'pre-wrap' }}
                                  dangerouslySetInnerHTML={{ __html: content }}
                                />
                              }
                            </FormLabel>
                            <Select
                              label={
                                <div
                                  style={{ whiteSpace: 'pre-wrap' }}
                                  dangerouslySetInnerHTML={{ __html: content }}
                                />
                              }
                              placeholder={
                                <div
                                  style={{ whiteSpace: 'pre-wrap' }}
                                  dangerouslySetInnerHTML={{ __html: content }}
                                />
                              }
                              defaultValue={values[content]}
                              value={values[content]}
                              onChange={(event, newValue) =>
                                setFieldValue(content, newValue.props.children)
                              }
                            >
                              {console.log(
                                'values[content]------',
                                values[content],
                              )}
                              {value?.options?.map((data) => (
                                <MenuItem key={data.label} value={data.label}>
                                  {data.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        )
                      case 'file':
                        return (
                          <>
                            <LabelStyle>
                              <div
                                style={{ whiteSpace: 'pre-wrap' }}
                                dangerouslySetInnerHTML={{ __html: content }}
                              />
                            </LabelStyle>
                            {/* <UploadSingleFile
                                            key={content}
                                            maxSize={1024 * 1024 * 1024}
                                            accept="image/*"
                                            file={values[content]}
                                            onDrop={(acceptedFiles) =>
                                              handleDropFile(
                                                acceptedFiles,
                                                field_id,
                                                content,
                                              )
                                            }
                                            /> */}
                            <UploadMultiFile
                              key={content}
                              maxSize={1024 * 1024 * 1024}
                              accept="image/*"
                              showPreview={true}
                              files={Object.keys(values)
                                .filter((key) => key.startsWith(content))
                                .map((key) => ({
                                  url: values[key]?.value,
                                  name: `Uploaded Image ${key}`,
                                  preview: values[key]?.value,
                                }))}
                              onDrop={(acceptedFiles) =>
                                handleDropFile(acceptedFiles, field_id, content)
                              }
                              onRemove={(fileToRemove) => {
                                setFieldValue((prevForm) => {
                                  let updatedForm = { ...prevForm }

                                  Object.keys(updatedForm).forEach((key) => {
                                    if (
                                      updatedForm[key]?.value ===
                                      fileToRemove.url
                                    ) {
                                      delete updatedForm[key]
                                    }
                                  })

                                  return { ...updatedForm }
                                })
                              }}
                              onRemoveAll={() => {
                                setFieldValue((prevForm) => {
                                  let updatedForm = { ...prevForm }

                                  Object.keys(updatedForm)
                                    .filter((key) => key.startsWith(content))
                                    .forEach((key) => {
                                      delete updatedForm[key]
                                    })

                                  return { ...updatedForm }
                                })
                              }}
                            />
                            <Box sx={{ mt: 1.5, mb: 0.5 }}>
                              <Button
                                variant="outlined"
                                color="primary"
                                startIcon={<PhotoCamera />}
                                onClick={() => handleOpenCamera(field_id, content)}
                              >
                                Take Photo
                              </Button>
                            </Box>
                          </>
                        )
                      case 'autocomplete':
                        return (
                          <FormControl>
                            <FormLabel id="demo-autocomplete-label">
                              <div
                                style={{ whiteSpace: 'pre-wrap' }}
                                dangerouslySetInnerHTML={{ __html: content }}
                              />
                            </FormLabel>
                            <Autocomplete
                              fullWidth
                              id="combo-box-demo"
                              defaultValue={values[content]}
                              value={values[content]}
                              options={(value?.options || [])?.map(
                                (option) => option.label,
                              )}
                              getOptionLabel={(option) => option}
                              onChange={(event, newValue) => {
                                setFieldValue(content, newValue)
                              }}
                              renderInput={(params) => (
                                <TextField {...params} />
                              )}
                            />
                          </FormControl>
                        )
                      case 'radio-group':
                        return (
                          <FormControl>
                            <FormLabel id="demo-radio-buttons-group-label">
                              <div
                                style={{ whiteSpace: 'pre-wrap' }}
                                dangerouslySetInnerHTML={{ __html: content }}
                              />
                            </FormLabel>
                            <RadioGroup
                              aria-labelledby="demo-radio-buttons-group-label"
                              name="radio-buttons-group"
                              value={values[content]}
                              onChange={(event) =>
                                setFieldValue(
                                  content,
                                  event.target.defaultValue,
                                )
                              }
                            >
                              {value?.options?.map((data) => (
                                <FormControlLabel
                                  key={data.value}
                                  value={data.label}
                                  control={<Radio />}
                                  label={data.label}
                                />
                              ))}
                            </RadioGroup>
                          </FormControl>
                        )
                      case 'checkbox-group':
                        return (
                          <FormControl>
                            <FormLabel id="demo-autocomplete-label">
                              <div
                                style={{ whiteSpace: 'pre-wrap' }}
                                dangerouslySetInnerHTML={{ __html: content }}
                              />
                            </FormLabel>
                            <Autocomplete
                              multiple
                              fullWidth
                              id="combo-box-demo"
                              defaultValue={values[content]}
                              value={values[content]}
                              options={(value?.options || [])?.map(
                                (option) => option.label,
                              )}
                              getOptionLabel={(option) => option}
                              onChange={(event, newValue) => {
                                setFieldValue(content, newValue)
                              }}
                              renderInput={(params) => (
                                <TextField {...params} />
                              )}
                            />
                          </FormControl>
                        )
                      default:
                        return null
                    }
                  })}
                {label === 'view_template' &&
                  templateData?.map((data) => {
                    const { name, content, field_id, installation_id, value } =
                      data
                    console.log('name--------------', name)
                    switch (name) {
                      case 'header':
                        return (
                          <Stack
                            direction={'row'}
                            alignItems={'center'}
                            justifyContent={'space-between'}
                            spacing={3}
                            marginLeft={2}
                            padding={3}
                          >
                            {/* <Typography variant="subtitle2">{sentenceCase(tag)}</Typography> */}
                            <Typography
                              variant="subtitle2"
                              sx={rightContentStyle}
                            >
                              {content
                                ? sentenceCase(parseContent(content))
                                : ''}
                            </Typography>
                          </Stack>
                        )
                      case 'paragraph':
                      case 'textarea':
                      case 'text':
                      case 'number':
                      case 'autocomplete':
                      case 'select':
                      case 'checkbox-group':
                      case 'radio-group':
                        return (
                          <Stack
                            direction={'row'}
                            alignItems={'center'}
                            justifyContent={'flex-start'}
                            spacing={3}
                            // marginLeft={2}
                          >
                            <Typography variant="subtitle2">
                              {content
                                ? `${sentenceCase(parseContent(content))} : `
                                : ''}
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              sx={rightContentStyle}
                            >
                              {value}
                            </Typography>
                          </Stack>
                        )
                      // case 'file':
                      // return (
                      //   <Stack
                      //     direction={'row'}
                      //     justifyContent={'flex-start'}
                      //     spacing={3}
                      //     marginLeft={2}
                      //   >
                      //     <Typography variant="subtitle2">{sentenceCase(parseContent(content))+' : '}</Typography>
                      //     <Stack direction="row" spacing={2} alignItems="center">
                      //       {value && (
                      //         <img
                      //           src={value}
                      //           alt={parseContent(content)}
                      //           style={{
                      //             width: '120px',
                      //             height: '120px',
                      //             borderRadius: '5px',
                      //             objectFit: 'fill'
                      //           }}
                      //           onClick={() => handleImageClick(value)}
                      //         />
                      //       )}
                      //     </Stack>
                      //   </Stack>
                      // );

                      case 'date':
                        return (
                          <Stack
                            direction={'row'}
                            alignItems={'center'}
                            justifyContent={'flex-start'}
                            spacing={1}
                          >
                            <Typography variant="subtitle2">
                              {sentenceCase(parseContent(content))}
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              sx={rightContentStyle}
                            >
                              {value}
                            </Typography>
                          </Stack>
                        )
                      default:
                        return null
                    }
                  })}
                {imageFiles.length > 0 && (
                  <Box sx={{ marginBottom: 3 }}>
                    {console.log('imageFilesimageFiles', imageFiles)}
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                      sx={{ marginBottom: 1 }}
                      spacing={1}
                      flexWrap="wrap"
                    >
                      <Typography variant="subtitle2">
                        {imageFiles[0].content}
                      </Typography>
                      {canExportPhotos && (
                        <Stack
                          direction="row"
                          alignItems="center"
                          spacing={1}
                          flexWrap="wrap"
                        >
                          <AttachmentDownloadAllButton
                            files={selectedPhotoDownloadFiles}
                            allFiles={installPhotoDownloadFiles}
                            onToggleSelectAll={handleToggleSelectAllPhotos}
                            selectionMode
                            label="Export Selected"
                            size="small"
                            onDownloadComplete={() => setSelectedPhotoKeys([])}
                          />
                          <AttachmentDownloadAllButton
                            files={installPhotoDownloadFiles}
                            label="Export All"
                            size="small"
                          />
                        </Stack>
                      )}
                       {canEmailPhotos && (
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={handleSendInstallPhotos}
                        >
                          Send Email ({selectedPhotoKeys.length})
                        </Button>
                      )}
                    </Stack>
                    <Grid container spacing={2}>
                      {imageFiles.map((imgSrc, index) => {
                        const selectKey = getInstallPhotoSelectKey(imgSrc, index)
                        const isSelected = selectedPhotoKeys.includes(selectKey)
                        return (
                          <Grid item xs={4} key={index}>
                            <Box
                              sx={{
                                position: 'relative',
                                width: '100%',
                                height: 120,
                                borderRadius: '5px',
                                overflow: 'hidden',
                                outline: isSelected ? '2px solid' : 'none',
                                outlineColor: 'primary.main',
                              }}
                            >
                              {canExportPhotos && (
                                <Checkbox
                                  size="small"
                                  checked={isSelected}
                                  onClick={(e) => e.stopPropagation()}
                                  onChange={(e) => {
                                    e.stopPropagation()
                                    handleTogglePhotoSelect(
                                      imgSrc,
                                      index,
                                      e.target.checked,
                                    )
                                  }}
                                  sx={{
                                    position: 'absolute',
                                    top: 2,
                                    left: 2,
                                    zIndex: 2,
                                    p: 0.25,
                                    color: 'common.white',
                                    bgcolor: 'rgba(255, 255, 255, 0.85)',
                                    borderRadius: '4px',
                                    '&.Mui-checked': {
                                      color: 'primary.main',
                                    },
                                  }}
                                />
                              )}
                               {canEmailPhotos && (
                                <Checkbox
                                  size="small"
                                  checked={isSelected}
                                  onClick={(e) => e.stopPropagation()}
                                  onChange={(e) => {
                                    e.stopPropagation()
                                    handleTogglePhotoSelect(
                                      imgSrc,
                                      index,
                                      e.target.checked,
                                    )
                                  }}
                                  sx={{
                                    position: 'absolute',
                                    top: 2,
                                    left: 2,
                                    zIndex: 2,
                                    p: 0.25,
                                    color: 'common.white',
                                    bgcolor: 'rgba(255, 255, 255, 0.85)',
                                    borderRadius: '4px',
                                    '&.Mui-checked': {
                                      color: 'primary.main',
                                    },
                                  }}
                                />
                              )}
                              <img
                                src={imgSrc?.value}
                                alt="Installation Image"
                                style={{
                                  width: '100%',
                                  height: '120px',
                                  borderRadius: '5px',
                                  objectFit: 'cover',
                                  cursor: 'pointer',
                                }}
                                onClick={() =>
                                  handleImageClick(imgSrc?.value, imageFiles)
                                }
                              />
                              <Box
                                sx={{
                                  position: 'absolute',
                                  top: 4,
                                  right: 4,
                                  zIndex: 1,
                                }}
                              >
                                <AttachmentDownloadIconButton
                                  file={toInstallPhotoDownloadFile(
                                    imgSrc,
                                    index,
                                  )}
                                  fileIndex={index}
                                  variant="overlay"
                                />
                              </Box>
                            </Box>
                          </Grid>
                        )
                      })}
                    </Grid>
                  </Box>
                )}
                {canUploadPhotos && fileFieldMeta && (
                  <Box sx={{ marginBottom: 3 }}>
                    <Button
                      variant="outlined"
                      onClick={() => setOpenAddPhotosModal(true)}
                    >
                      Add Photos
                    </Button>
                  </Box>
                )}
                {label !== 'view_template' && (
                  <Box
                    sx={{
                      mt: 3,
                      display: 'flex',
                      justifyContent: 'flex-end',
                      gap: 1,
                    }}
                  >
                    <LoadingButton
                      type="submit"
                      variant="contained"
                      loading={isSubmitting}
                    >
                      Save and Publish
                    </LoadingButton>

                    <Button
                      variant="outlined"
                      onClick={() => {
                        setOpenEdit(false)
                      }}
                    >
                      Cancel
                    </Button>
                  </Box>
                )}
              </Stack>
              {/* </Card> */}
            </Grid>
          </Grid>
        </Form>
      </FormikProvider>
      <Modal
        width={800}
        open={openImageModal}
        handleClose={() => setOpenImageModal(false)}
        modalTitle={imageFiles[0]?.content}
      >
        <div
          style={{
            position: 'relative',
            width: '100%',
            height: '100%',
            display: 'flex',
            gap: '1rem',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <IconButton
            onClick={handlePrevious}
            disabled={currentImageIndex === 0}
            sx={{
              opacity: currentImageIndex === 0 ? 0.3 : 1,
              pointerEvents: currentImageIndex === 0 ? 'none' : 'auto',
            }}
          >
            <Icon
              icon={arrowLeftOutlined}
              width={24}
              height={24}
              color="#006097"
            />
          </IconButton>

          <Box
            component={'div'}
            style={{
              position: 'relative',
              width: '400px',
              height: '400px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: 8,
              overflow: 'hidden',
            }}
          >
            <img
              src={imageList[currentImageIndex]}
              alt="Selected Image"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: 8,
              }}
            />
            {imageList[currentImageIndex] && (
              <Box
                sx={{
                  position: 'absolute',
                  top: 8,
                  right: 8,
                  zIndex: 1,
                }}
              >
                <AttachmentDownloadIconButton
                  file={toInstallPhotoDownloadFile(
                    imageList[currentImageIndex],
                    currentImageIndex,
                  )}
                  fileIndex={currentImageIndex}
                  variant="overlay"
                />
              </Box>
            )}
          </Box>

          <IconButton
            onClick={handleNext}
            disabled={currentImageIndex === imageList.length - 1}
            sx={{
              opacity: currentImageIndex === imageList.length - 1 ? 0.3 : 1,
              pointerEvents:
                currentImageIndex === imageList.length - 1 ? 'none' : 'auto',
            }}
          >
            <Icon
              icon={arrowRightOutlined}
              width={24}
              height={24}
              color="#006097"
            />
          </IconButton>
        </div>
      </Modal>
      <Dialog
        open={cameraOpen}
        onClose={handleCloseCamera}
        maxWidth="sm"
        fullWidth
        disableEnforceFocus
        TransitionProps={{
          onEntered: () => {
            attachStreamToVideo()
          },
        }}
        PaperProps={{
          sx: {
            m: { xs: 1, sm: 2 },
            width: { xs: 'calc(100% - 16px)', sm: '100%' },
          },
        }}
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 1 }}>
          Take Photo
          <IconButton onClick={handleCloseCamera} size="small" aria-label="close camera">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              width: '100%',
              bgcolor: '#000',
              borderRadius: 1,
              overflow: 'hidden',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: { xs: 240, sm: 320 },
            }}
          >
            <video
              ref={videoRef}
              autoPlay
              playsInline
              muted
              controls={false}
              style={{
                width: '100%',
                maxHeight: '70vh',
                minHeight: 240,
                objectFit: 'cover',
                backgroundColor: '#000',
              }}
            />
          </Box>
          <canvas ref={canvasRef} style={{ display: 'none' }} />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, gap: 1, flexWrap: 'wrap' }}>
          <Button variant="outlined" onClick={handleCloseCamera} disabled={isCapturingPhoto}>
            Cancel
          </Button>
          <LoadingButton
            variant="contained"
            color="primary"
            startIcon={<PhotoCamera />}
            onClick={handleCapturePhoto}
            loading={isCapturingPhoto}
          >
            Capture
          </LoadingButton>
        </DialogActions>
      </Dialog>
      <Modal
        open={openAddPhotosModal}
        handleClose={() => {
          setOpenAddPhotosModal(false)
          setPendingPhotos([])
        }}
        modalTitle="Add Install Photos"
      >
        <UploadMultiFile
          accept="image/*"
          maxSize={1024 * 1024 * 1024}
          showPreview
          files={pendingPhotos.map((photo, index) => ({
            url: photo.value,
            name: photo.name || `New photo ${index + 1}`,
            preview: photo.preview || photo.value,
          }))}
          onDrop={handleDropPendingPhotos}
          onRemove={handleRemovePendingPhoto}
          onRemoveAll={() => setPendingPhotos([])}
        />
        <Stack direction="row" justifyContent="flex-end" sx={{ mt: 2, gap: 1 }}>
          <Button
            variant="outlined"
            onClick={() => {
              setOpenAddPhotosModal(false)
              setPendingPhotos([])
            }}
          >
            Cancel
          </Button>
          <LoadingButton
            variant="contained"
            loading={savingPhotos}
            disabled={!pendingPhotos.length}
            onClick={handleSaveNewPhotos}
          >
            Save Photos
          </LoadingButton>
        </Stack>
      </Modal>
      <SendDesignsEmailModal
        open={openInstallEmailModal}
        onClose={() => setOpenInstallEmailModal(false)}
        selectedDesigns={emailModalReports}
        installationId={instId}
        installationOrderNumber={orderNumber}
        installationName ={installationName}
        installationJobName={installationJobName}
        projectName ={projectName}
        clientName={clientName}
        installNote={resolvedInstallNote}
        teamNames={teamNames}
        userId={userData?.user_id}
        userType={userType}
        onSuccess={() => {
          setOpenInstallEmailModal(false)
          setSelectedPhotoKeys([])
        }}
        pageType="installation_report"
      />
    </Modal>
  )
}
